import {
    Button,
    Flex,
    NumberInput,
    Select,
    SelectItem,
    Text,
    TextInput,
} from '@tremor/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApiV1TicketCreate } from '../../api/api.gen'
import { toErrorText } from '../../utilities/error'
import { ModelVMType } from '../../api/api'

export default function ManagedKubernetesTicketModal() {
    const [clusterName, setClusterName] = useState<string>('')
    const [nodePoolSize, setNodePoolSize] = useState<number>(0)
    const [nodeType, setNodeType] = useState<ModelVMType>(
        ModelVMType.VMTypeBurstable2Core4GB
    )

    const {
        response: createTicketResponse,
        isLoading: createTicketLoading,
        isExecuted: createTicketExecuted,
        sendNowWithParams: createTicket,
        error: createError,
    } = useApiV1TicketCreate({}, {}, {}, false)

    const navigate = useNavigate()
    useEffect(() => {
        if (createTicketExecuted && !createTicketLoading) {
            navigate(`/ticket/${createTicketResponse}#close_sidebar_modal`)
        }
    }, [createTicketLoading])

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto max-w-fit rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Text className="mt-4 mb-1">Cluster name:</Text>
            <TextInput
                value={clusterName}
                onValueChange={setClusterName}
                error={clusterName.length === 0}
                errorMessage="Cluster name is required"
            />

            <Text className="mt-4 mb-1">NodePool size:</Text>
            <NumberInput
                value={nodePoolSize}
                onValueChange={(v) => setNodePoolSize(v)}
                error={nodePoolSize === 0}
                errorMessage="NodePool size must be greater than zero"
            />

            <Text className="mt-4 mb-1">Node type:</Text>
            <Select
                value={nodeType}
                onValueChange={(v) => {
                    setNodeType(v as ModelVMType)
                }}
                error={nodeType.length === 0}
                errorMessage="Type is required"
            >
                <SelectItem value={ModelVMType.VMTypeBurstable2Core4GB}>
                    2cores, 4GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeBurstable4Core16GB}>
                    4cores, 16GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeComputeOptimized8Core16GB}>
                    8cores, 16GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeMemoryOptimized8Core32GB}>
                    8cores, 32GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeMemoryIntensive8Core64GB}>
                    8cores, 64GB
                </SelectItem>
            </Select>

            <div className="mt-8">{toErrorText(createError)}</div>
            <Button
                className=""
                color="teal"
                loading={createTicketExecuted && createTicketLoading}
                disabled={createTicketExecuted && createTicketLoading}
                onClick={() => {
                    createTicket(
                        {
                            id: 0,
                            newTicket: true,
                            title: 'Request for Managed Kubernetes Cluster',
                            content: `Managed Kubernetes Cluster with following configuration
Cluster name: ${clusterName}
NodePool size: ${nodePoolSize} nodes
Node type: ${nodeType}`,
                        },
                        { service: 'Kubernetes Cluster' },
                        {}
                    )
                }}
            >
                Create
            </Button>
        </Flex>
    )
}
